import { SVGProps } from "react";

const CalendarIcon = (props: SVGProps<SVGSVGElement>) => {
  const { width = 24, height = 24 } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.40588 3.52158H4.00588C3.12223 3.52158 2.40588 4.23793 2.40588 5.12158V20.1216C2.40588 21.0052 3.12223 21.7216 4.00588 21.7216H20.0059C20.8895 21.7216 21.6059 21.0052 21.6059 20.1216V5.12158C21.6059 4.23793 20.8895 3.52158 20.0059 3.52158H17.6059V1.12158H16.4059V3.52158H7.60588V1.12158H6.40588V3.52158ZM4.00588 4.72158C3.78497 4.72158 3.60588 4.90067 3.60588 5.12158V8.47158H20.4059V5.12158C20.4059 4.90067 20.2268 4.72158 20.0059 4.72158H4.00588ZM20.4059 9.67158H3.60588V20.1216C3.60588 20.3425 3.78497 20.5216 4.00588 20.5216H20.0059C20.2268 20.5216 20.4059 20.3425 20.4059 20.1216V9.67158Z"
        fill="black"
      />
    </svg>
  );
};

export default CalendarIcon;
